import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20abstract%20composition%20with%20hot%20pink%20and%20deep%20black%20geometric%20shapes%2C%20modern%20editorial%20style%2C%20mysterious%20atmosphere%2C%20high%20contrast%2C%20vibrant%20neon%20pink%20accents%20against%20dark%20background%2C%20digital%20art%2C%20bold%20graphic%20design%2C%20clean%20lines%2C%20sophisticated%20noir%20aesthetic&width=1800&height=1200&seq=hero-bg-2026&orientation=landscape"
          alt="51黑料网 重磅爆料"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full lg:w-2/5 pt-8 md:pt-16">
            <p className="text-primary-400 text-xs md:text-sm font-semibold tracking-widest uppercase mb-4">
              🔥 黑料吃瓜第一站 · 24小时不打烊
            </p>
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-black text-background-50 leading-none tracking-tight">
              深度揭秘<br />
              <span className="text-primary-500">圈内热点</span>内幕
            </h1>
            <p className="mt-5 text-sm md:text-base text-foreground-200 leading-relaxed max-w-md">
              整合全网独家网红明星爆料与每日大赛正能量资源，吃瓜群众聚集地，海量资源免费查看，欢迎回家！
            </p>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 mt-7">
              <Link
                to="/category/meiri-dasai"
                className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                立即吃瓜
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-7 py-3.5 border border-background-50/30 text-background-50 font-medium text-sm rounded-full hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                了解更多
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>

          <div className="flex-1 w-full lg:w-3/5 relative">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20editorial%20fashion%20style%20night%20scene%20with%20mysterious%20figure%20silhouette%2C%20hot%20pink%20neon%20glow%2C%20luxury%20urban%20nightlife%20vibe%2C%20cinematic%20lighting%2C%20dark%20moody%20atmosphere%2C%20paparazzi%20flash%20effect%2C%20high%20fashion%20aesthetic&width=1000&height=700&seq=hero-feature-2026&orientation=landscape"
                alt="独家爆料精选"
                className="w-full h-auto object-cover rounded-2xl"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-5 md:p-7">
                <span className="inline-block px-3 py-1 bg-primary-500 text-background-50 text-xs font-semibold rounded-full mb-2">
                  今日重磅
                </span>
                <p className="text-background-50 font-bold text-base md:text-lg">
                  某知名男星深夜密会神秘女子，独家画面首次曝光
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-4 md:gap-6 mt-12 md:mt-16 pb-8">
          <span className="text-xs text-foreground-300 whitespace-nowrap">热门标签：</span>
          {['明星恋情', '综艺内幕', '选秀黑幕', '网红塌房', '资本博弈', '合约纠纷'].map((tag) => (
            <Link
              key={tag}
              to="/"
              className="text-xs text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              #{tag}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}